/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import WebComponent from './main';
import EditWebComponent from './edit/main';
import NewWebComponent from './new/main';

export const web = (context, next) => {
    context.primary = <WebComponent />;
    next();
};

export const editWeb = (context, next) => {
    context.primary = <EditWebComponent />;
    next();
};

export const newWeb = (context, next) => {
    context.primary = <NewWebComponent />;
    next();
};